import React from 'react'

const Footer = () => {
    return (
        <div> 
            {/* Footer */}
            <footer className="footer">
                <div className="container-fluid">
                    <h3 style={{fontSize: 24}}>Copyrights</h3>
                </div>
            </footer></div>
    )
}

export default Footer